import React from 'react'

export default function SettingsPage() {
  return (
    <div className='page-admin container py-4'>
      <h1>Perfil</h1>

      <div className="img-profile">
        <img src="https://cdn-icons-png.flaticon.com/512/3135/3135768.png" alt="" />
        <div className="upload-btn">
          <input type="file" id="uploadFile" accept=".jpg,.png,.jpeg" />
          <label for="uploadFile">Cambiar imagen</label>
        </div>
      </div>

      <div className="form-group">
        <input type="text" className="form-control" id="name" placeholder="Nombre completo" />
      </div>

      <div className="form-group">
        <input type="email" className="form-control" id="email" placeholder="Correo electrónico" />
      </div>
    </div>
  )
}
